import { tutorReplySchema, tutorThreadSchema, type TutorKind } from "@studyward/shared";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import { useSession } from "./session";

export const assistKeys = { hoot: (setId: string) => ["hoot", setId] as const };

/** The conversation with Ask Hoot about one set, and how many questions the plan allows on it. */
export function useHootThread(setId: string) {
  return useQuery({
    queryKey: assistKeys.hoot(setId),
    queryFn: () => api.get(`/sets/${setId}/tutor/threads`, tutorThreadSchema),
    enabled: useSession().status === "signed_in" && !!setId,
  });
}

/** One turn: a question, a practice hint ("hint") or a simpler explanation ("explain_simpler"). */
export function useAskHoot(setId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: { content: string; kind?: TutorKind; question_id?: string | null; allow_general_knowledge?: boolean }) =>
      api.post(`/sets/${setId}/tutor/messages`, tutorReplySchema, { kind: "ask", ...body }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: assistKeys.hoot(setId) }),
  });
}
